<template>
  <div class="gerenciar-sugestoes">
    <nav-menu></nav-menu>

    <div class="w3-main w3-animate-left" style="margin-top:43px;">
      <div class="w3-container w3-white" id="gerenciamento-sugestoes">
        <header class="w3-row" style="padding-top:22px">
          <h5 class="w3-left w3-col s12 m7"><b><i class="far fa-comment">
            </i>  Gerenciamento de sugestão</b>
          </h5>
          
          <div>
            <span data-span="selecionar-empresas" class="w3-col texto-vermelho w3-left">
              <i class="fas fa-building"></i>
              <a  @click="mostrarModalInserirEmpresas = true" href="#">Selecionar Empresas</a>
            </span>
            
            <div 
              style="font-size: 14px;"
              class="w3-conteiner w3-col">
              <span>{{getEmpresasSelecionadas}}</span>
            </div>
          </div>
        </header>
        
        <div 
          class="w3-row w3-margin-top"
          :class="{ 'fade-in': mostrarDetalhesPesquisa, 'fade-out': !mostrarDetalhesPesquisa }">
        
          <div class="w3-row">
            <div class="w3-col s6 w3-padding-right w3-margin-top">
              <label>Tipo</label>
              <select class="w3-select w3-border" v-model="tipo_selecionado">
                <option value="T">Todos</option>
                <option value="C">Críticas</option>
                <option value="S">Sugestões</option>
                <option value="E">Elogios</option>
              </select>
            </div>
            <div class="w3-col s6 w3-margin-top">
              <label>Status</label>
              <select class="w3-select w3-border" v-model="status_selecionado">
                <option value="TPE">Todas pendentes</option>
                <option value="ABE">Abertos</option>
                <option value="IMP">Em implementação</option>
                <option value="BAI">Baixados</option>
                <option value="CAN">Cancelados</option>
              </select>
            </div>
          </div><br>
        
        </div>

          <h3 class="texto-vermelho titulo w3-col w3-margin-bottom">
            <span>Sugestões</span>
          </h3>

          <div class="w3-panel w3-col" v-if="processando">
            <p class=" w3-theme w3-card-2 w3-padding"> <i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
          </div>

          <div v-if="sugestoes_filtradas.length == 0 && !processando">
            Não foram encontradas sugestões a serem exibidas.
          </div>

          <div 
            class="w3-animate-left w3-col w3-padding-small"
            v-for="(sugestao, sugestao_index) in sugestoes_filtradas"
            :key="sugestao_index" 
            v-cloak>
            
            <div class="card-itens w3-border w3-padding-small">
              <div class="w3-row-padding label-clicavel" v-on:click="mostrarModalDetalhes(sugestao, sugestao_index)">
                <span class="texto-vermelho">
                  <b>
                  
                    <span v-if="sugestao.tipo == 'S'"> <i class="far fa-lightbulb"></i>&nbsp;{{sugestao.sugestao_id}} - SUGESTÃO</span>
                    <span v-if="sugestao.tipo == 'C'"><i class="far fa-thumbs-down"></i>&nbsp;{{sugestao.sugestao_id}} - CRÍTICA</span>
                    <span v-if="sugestao.tipo == 'E'"><i class="far  fa-thumbs-up"></i>&nbsp;{{sugestao.sugestao_id}} - ELOGIO</span>
                  </b>
                </span>
                <span class="w3-right">{{sugestao.data_hora_cadastro}}</span>
                <br>
                <span class="texto-preto">{{sugestao.empresa_id}} - {{sugestao.nome_empresa}}</span>
                <span class="w3-right ">
                  <i style="color: hsl(130, 96%, 19%)" class="fa fa-circle" v-if="sugestao.tipo == 'S'"></i>
                  <i style="color: hsl(56, 96%, 30%)" class="fa fa-circle" v-if="sugestao.tipo == 'C'"></i>
                  <i style="color: #070cb6bd" class="fa fa-circle" v-if="sugestao.tipo == 'E'"></i>
                </span>
                <br>
                <span
                  class="texto-cinza"
                  v-if="sugestao.departamento_id > 0">
                  Departamento:   {{sugestao.departamento_id}} - {{sugestao.nome_departamento}}
                </span>
                <span v-else class="texto-cinza">Departamento:  Não informado</span>
              </div>
            </div>
          </div>
          
          <button 
            title="Atualizar mensagens"
            id="floating-button" 
            class="w3-button w3-theme w3-circle w3-display-bottomright"
            v-on:click="buscarSugestoes()" 
            style="border-radius: 50% !important">
            <i class="fa fa-sync-alt"></i>
          </button>
        </div>

        <div 
          id="modalDetalhesSugestao"
          v-if="mostrarModalDetalhesSugestao"
          style="display: block"
          @click="mostrarModalDetalhesSugestao = false" 
          class="w3-modal">
          
          <div class="w3-modal-content w3-animate-zoom" @click.stop>
            <header class="w3-container">
              <span @click="mostrarModalDetalhesSugestao = false" class="w3-button w3-display-topright">&times;</span>
              <h4 class="texto-vermelho titulo"><i class="fas fa-comment"></i> Detalhes da sugestão</h4>
            </header>
            
            <div>
              <div>
                <div class="w3-responsive">
                  <div class="w3-row-padding">
                    <div class="w3-col s12 m12 l6">
                      <label class="w3-col s2 label-info w3-small">Tipo</label>
                      <strong class="w3-col s10 line-label w3-small" v-if="sugestao_selecionada.tipo == 'S'">SUGESTÃO</strong>
                      <strong class="w3-col s10 line-label w3-small" v-if="sugestao_selecionada.tipo == 'C'">CRÍTICA</strong>
                      <strong class="w3-col s10 line-label w3-small" v-if="sugestao_selecionada.tipo == 'E'">ELOGIO</strong>
                    </div>
                    
                    <div class="w3-col s12 m12 l6">
                      <label class="w3-col s2 label-info w3-small">Empresa</label>
                      <strong class="w3-col s10 line-label w3-small">
                        {{sugestao_selecionada.empresa_id}} - {{sugestao_selecionada.nome_empresa}}
                      </strong>
                    </div>
                    
                    <div class="w3-col s12 m12 l6">
                      <label class="w3-col s2 label-info w3-small">Departamento</label>
                      <strong 
                        class="w3-col s10 line-label w3-small" 
                        v-if="sugestao_selecionada.departamento_id != 0">
                        {{sugestao_selecionada.departamento_id}} - {{sugestao_selecionada.nome_departamento}}
                      </strong>
                      <strong class="w3-col s10 line-label w3-small" v-else>Não informado</strong>
                    </div>
                    
                    <div class="w3-col s12 m12 l6">
                      <label class="w3-col s2 label-info w3-small">Usuário</label>
                      <strong 
                        class="w3-col s10 line-label w3-small" 
                        v-if="sugestao_selecionada.usuario_sugestao != undefined">
                        {{sugestao_selecionada.usuario_sugestao}}
                      </strong>
                      <strong class="w3-col s10 line-label w3-small" v-else>Não informado</strong>
                    </div>
                    
                    <div class="w3-col s12 m12 l6" style="padding-top: 3px;">
                      <label class="w3-col s5 label-info w3-small">Status</label>
                      <div class="w3-col s7 w3-small line-label">
                        <select 
                          style="padding: 0; height: 35px !important;"
                          class="w3-select w3-mobile w3-border w3-right"
                          v-model="sugestao_selecionada.status" 
                          @change="gravarSugestao(
                            sugestao_selecionada.sugestao_id, 
                            sugestao_selecionada.tipo, 
                            sugestao_selecionada.empresa_id,
                            sugestao_selecionada.departamento_id, 
                            sugestao_selecionada.texto, 
                            sugestao_selecionada.usuario_sugestao
                          )">
                          <option value="ABE">ABERTA</option>
                          <option value="IMP">EM IMPLEMENTAÇÃO</option>
                          <option value="BAI">BAIXADA</option>
                          <option value="CAN">CANCELADA</option>
                        </select>
                      </div>
                    </div>
                    
                    <div class="w3-col s12 m12 l6">
                      <label class="w3-col s2 label-info w3-small">Data</label>
                      <strong class="w3-col s10 line-label w3-small">{{sugestao_selecionada.data_hora_cadastro}}</strong>
                    </div>
                    
                    <br><br>
                    <div class="w3-col s12" style="margin-top: 5px">
                      <label class="w3-small">Texto recebido</label><br>
                      <div 
                        class="w3-col w3-padding texto-auto-expansivel w3-justify w3-border" 
                        style="background-color: #f1f1f1">
                        {{sugestao_selecionada.texto}}
                      </div>
                    </div>
                    
                    <div class="w3-col s12" style="margin-top: 5px">
                      <div class="w3-col s8 m10 w3-padding-right">
                        <label class="w3-small">Texto</label>
                        <input 
                          class="w3-input w3-border w3-padding w3-small" 
                          style="padding: 3px;!important; "
                          type="text"
                          v-model="texto_tramite" 
                          @keyup.enter="inserirTextoTramites()" 
                          placeholder="Digite o texto do trâmite a ser inserido...">
                      </div><br>
                      
                      <div class="w3-col s4 m2">
                        <button 
                          class="w3-button w3-theme w3-right"
                          style="width: 100%"
                          v-on:click="inserirTextoTramites()">
                          <i class="fas fa-plus"/> Inserir
                        </button>
                      </div>
                      
                      <div class="w3-col s12">
                        <div 
                          class="w3-row border" 
                          style="margin-top: 7px" 
                          v-for="(tramite, index) in tramites"
                          :key="index"
                          v-cloak>
                          
                          <div class="w3-container w3-border w3-small" style="padding: 10px 10px">
                            <div class="w3-col" style="margin-bottom: 5px">
                              <label class="texto-vermelho w3-left">
                              <strong>
                                {{tramite.usuario_insercao}} - {{tramite.usuario_insercao_nome}} | {{tramite.data_cadastro}}
                              </strong></label>
                              <button
                                v-if="tramite.pode_excluir=='S'"
                                class="w3-button w3-theme w3-tiny w3-right w3-hide-small w3-hide-medium"
                                @click="excluirTramite(tramite)">
                                <i class="fa fa-trash w3-center"></i>
                              </button>
                            </div>
                            
                            <div>
                              <textarea class="w3-col w3-small" rows="3" readonly style="resize: none;" v-model="tramite.texto"/>
                            </div>
                            
                            <div class="w3-col w3-margin-top w3-hide-large" style="display: flex; justify-content: center;">
                              <button 
                                v-if="tramite.pode_excluir=='S'" 
                                class="w3-button w3-theme w3-tiny w3-right"
                                @click="excluirTramite(tramite)">
                                <i class="fa fa-trash w3-center"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div class="w3-col">
                        <p 
                          class="w3-center texto-cinza"
                          v-show="tramites.length==0 && !processando_tramites">
                          Não há tramites inseridos.
                        </p>
                      </div>
                      
                      <div class="w3-col w3-panel w3-theme w3-card-2" v-if="processando_tramites">
                        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <footer class="w3-container conteudo-centralizado">
              <button
                class="w3-btn w3-theme" 
                id="btn-confirmar-acao" 
                style="margin-top: 10px; margin-bottom:10px"
                @click="mostrarModalDetalhesSugestao = false">
                <i class="fas fa-check-circle"/> Ok
              </button>
            </footer>
          </div>
        </div>
        <!-- Fim modal Detalhes da sugestÃ£o -->

        <!--inicio modal empresa-->
        <div 
          id="modalInserirEmpresas" 
          style="display: block" 
          v-if="mostrarModalInserirEmpresas" 
          class="w3-modal w3-card card-item">
          
          <div class="w3-modal-content w3-card w3-animate-zoom card-item" @click.stop>
                
            <div data-div="empresas-disponiveis" class="w3-container card-item">
              <span 
                @click="mostrarModalInserirEmpresas = false"
                class="w3-button w3-display-topright">&times;</span>
              <h2 class="texto-vermelho titulo">Empresas Disponíveis</h2>
            </div>
              
            <thead
              data-thead="empresa-selecionando"
              class="w3-col w3-padding"
              style="margin-top: 6px;"
              :key="'empresa-selecionada' + empresa.empresa_id"
              v-for="empresa in empresas" 
              :class="getClasseEmpresaDisponivel(empresa.adicionado)" 
              v-on:click="adicionarRemoverEmpresa(empresa.empresa_id)">
            
              <strong class="w3-col">
                <i v-if="empresa.adicionado" class="far fa-check-square"></i>
                <i v-if="!empresa.adicionado" class="far fa-square"></i>
                &nbsp;&nbsp;
                {{empresa.empresa_id}} - {{empresa.nome_fantasia}}
                <a class="w3-hide-small">  -  {{empresa.cnpj}}</a>
              </strong>
            </thead>
              
            <footer class="w3-container conteudo-centralizado">
              <button 
                data-buttom="ok"
                class="w3-btn w3-theme" 
                id="btn-confirmar-acao" 
                style="margin-top: 10px; margin-bottom:10px"  
                v-on:click="mostrarModalInserirEmpresas = false, filtrarSugestoes()"            
                >
                OK
              </button>
            </footer>
    
          </div>
        </div>  
        
      </div>
      <div id="carregar_rodape"></div>
    </div>

</template>

<script>
  import NavMenu from '@/components/Menu'
  import RSugestao from '@/components/Rest/RSugestao.js'
  import RSugestaoTramite from '@/components/Rest/RSugestaoTramite.js'
  import REmpresa from '@/components/Rest/REmpresa.js'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  
  export default {
    name: 'GerenciarSugestoes',
    components: {
      NavMenu
    },
    data() {
      return {
        api: process.env.API,
        sugestao_id: '0',
        sugestoes_filtradas: [],
        sugestoes_recebidas: [],
        sugestao_selecionada: {},
        tramites: [],
        empresas_selecionadas: [],
        empresas: [],
        processando: false,
        tipo_selecionado: 'T',
        status_selecionado: 'TPE',
        texto_tramite: '',
        usuario_id: '',
        usuario_nome: '',
        data_atual: '',
        usuario_sugestao: '',
        departamento_id: '',
        processando_tramites: false,
        mostrarModalInserirEmpresas: false,
        mostrarModalDetalhesSugestao: false,
        mostrarDetalhesPesquisa: true,
      }
    },
    watch: {
      mostrarModalInserirEmpresas() {
        this.verificarModalAberto()
      },
      mostrarModalDetalhesSugestao() {
        this.verificarModalAberto()
      },
    },
    computed: {
      getEmpresasSelecionadas() {
        let contador_empresas_selecionadas = 0;
        let retorno = '';
        
        for (let i = 0; i < this.empresas.length; i++) {
          if (this.empresas[i].adicionado) {
            if (retorno != '') {
              retorno += ' / ';
            } 
            retorno += this.empresas[i].empresa_id + ' - ' + this.empresas[i].nome_fantasia;
            contador_empresas_selecionadas++;
          }
        }

        if (retorno == '') {
          return 'Nenhuma empresa foi selecionada.';
        }
        else if(contador_empresas_selecionadas == this.empresas.length){
          return 'Todas empresas foram selecionadas.';
        }

        else {
          return retorno;
        }
      },
      verificarModal() {
        if (this.mostrarModalInserirEmpresas || this.mostrarModalDetalhesSugestao) return true
        else return false
      }
    },
    methods: {
      async adicionarRemoverEmpresa(empresa_id){
        this.empresas_selecionadas = []
        for (let i in this.empresas) {
        
          if (this.empresas[i].empresa_id != empresa_id) {
            continue;
          }
          
          await (this.empresas[i].adicionado = !this.empresas[i].adicionado);
        
          break;
        }
        for(let k in this.empresas){
          if(this.empresas[k].adicionado){
            this.empresas_selecionadas[k] = this.empresas[k]
          }
        }
        
        if(!this.empresas_selecionadas){
          this.sugestoes_filtradas = [];
        }
        await (this.empresas = JSON.parse(JSON.stringify(this.empresas)));
      },
      getClasseEmpresaDisponivel: function(adicionado){
        if (adicionado) {
          return 'w3-theme label-clicavel';
        } else {
          return 'label-clicavel';
        }
      },

      verificarModalAberto(){
        const el = document.documentElement
        if (this.verificarModal) {
          el.classList.add('modal-aberto');
        } else {
          el.classList.remove('modal-aberto');
        }
      },

      mostrarModal: function(elementoId) {
        document.getElementById(elementoId).style.display = "block";
      },

      async buscarSugestoes(){
        try {
          this.tipo_selecionado = 'T';
          this.sugestoes_recebidas = [];
          this.sugestoes_filtradas = [];
          this.processando = true;
        
          let retorno = await RSugestao.buscarSugestao(this.axios);
          
          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          } 

          this.processando = false;
          this.sugestoes_filtradas = retorno.dados.slice(0);
          this.sugestoes_recebidas = retorno.dados.slice(0);
          this.filtrarSugestoes();
        } catch (e) {
          this.processando = false;
          Biblioteca.exclamar(e.message);
        }
      },

      async buscarEmpresas(){
        try {
          this.processando = true;
        
          let retorno = await REmpresa.buscarEmpresasSugestao(this.axios);
          
          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.empresas = retorno.dados;
          this.processando = false;
          this.buscarSugestoes();
        } catch (e) {
          this.processando = false;
          Biblioteca.exclamar(e.message);
        }
      },

      async buscarTramiteSugestoes(){
        try {
          this.processando_tramites = true;
          this.tramites = [];

          let parametros = {
            sugestao_id: this.sugestao_selecionada.sugestao_id
          }
      
          let retorno = await RSugestaoTramite.buscarTramites(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.tramites = retorno.dados.tramites;
          this.data_atual = retorno.dados.data_atual;
          this.processando_tramites = false;
        } catch (e) {
          this.processando_tramites = false;
          Biblioteca.exclamar(e.message);
        }
      },

      mostrarModalDetalhes: function(sugestao, sugestao_index){
        this.sugestao_selecionada = {};
        this.tramites = [];
        this.sugestao_selecionada = Object.assign({}, sugestao);

        this.buscarTramiteSugestoes();
        this.mostrarModalDetalhesSugestao = true
      },

      getClasseDisponivel: function(adicionado){
        if (adicionado) {
          return 'w3-theme label-clicavel';
        }
        else {
          return 'w3-white label-clicavel';
        }
      },

      async gravarSugestao(
        sugestao_id,
        tipo_sugestao,
        empresa_id,
        departamento_id,
        texto,
        usuario_sugestao
      ){
        try {
          let parametros = {
            sugestao_id: sugestao_id,
            tipo: tipo_sugestao,
            empresa_id: empresa_id,
            departamento_id: departamento_id,
            texto: texto,
            usuario_sugestao: usuario_sugestao,
            status: this.sugestao_selecionada.status
          }

          this.processando = true;

          let retorno = await RSugestao.enviarSugestao(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          for (let i = 0; i  < this.sugestoes_filtradas.length; i++){
            if (this.sugestoes_filtradas[i].sugestao_id == this.sugestao_selecionada.sugestao_id){
              this.sugestoes_filtradas[i].status = this.sugestao_selecionada.status;
              break;
            }
          }

          this.processando = false;
          Biblioteca.informar("Status alterado com sucesso!");
        } catch (error) {
          this.processando = false;
          Biblioteca.exclamar(e.message);
        }
      },

      async inserirTextoTramites(){
        try {
          if (this.texto_tramite.trim() == ''){
            Biblioteca.exclamar("É necessário informar um texto válido para o trâmite!");
            return;
          }

          let parametros = {
            sugestao_id: this.sugestao_selecionada.sugestao_id,
            texto: this.texto_tramite
          }

          this.processando = true;

          let retorno = await RSugestaoTramite.enviarTramite(this.axios, parametros);
          
          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.processando = false;

          this.texto_tramite = '';
          Biblioteca.informar('Trâmite inserido com sucesso!');
          this.buscarTramiteSugestoes();
        } catch (e) {
          this.processando = false;
          Biblioteca.exclamar(e.message);
        }
      },

      excluirTramite: function(tramite){
        swal("Deseja realmente excluir o trâmite?", {
          buttons: {
            nao: "Não",
            sim: "Sim",
          },
        })
        .then(async (value) => {
          switch (value) {
            case "sim":

              try {
	    
                let parametros = {
                  tramite_id: tramite.tramite_id
                }

                this.processando = true;

                let retorno = await RSugestaoTramite.excluirTramite(this.axios, parametros);
                
                if (retorno.houve_erro == 'S'){
                  throw new Error(retorno.mensagem);
                }

                this.processando = false;

                await swal({
                  title: "Mensagem",
                  text: "Trâmite excluido com sucesso.",
                  icon: "success",
                  button: {
                    confirm: {
                      text: "OK",
                      value: true,
                      visible: true,
                      closeModal: true,
                    },
                  },
                })
                .then((value) => {
                  this.buscarTramiteSugestoes();
                });
              } catch (e) {
                this.processando = false;
                Biblioteca.exclamar(e.message);
              }

            break;
          }
        });
      },

      getTextoResumido: function(texto){
        return texto.slice(0, 40)
      },

      filtrarSugestoes(){
        this.sugestoes_filtradas = [];

        for (let i = 0; i < this.sugestoes_recebidas.length; i++){
          if
            ((this.sugestoes_recebidas[i].tipo == this.tipo_selecionado || this.tipo_selecionado == 'T') &&
            (
              this.sugestoes_recebidas[i].status == this.status_selecionado ||
              (this.status_selecionado == 'TPE' && (this.sugestoes_recebidas[i].status == 'ABE' || this.sugestoes_recebidas[i].status == 'IMP')))
            )
          {
            for (let j in this.empresas_selecionadas){
              if (this.empresas_selecionadas[j].empresa_id == this.sugestoes_recebidas[i].empresa_id){
                this.sugestoes_filtradas.push(this.sugestoes_recebidas[i]);
              }
            }
          }

        }
      }
    },
    async created(){
      await this.buscarEmpresas();
    }
  }
</script>

<style scoped>
  .tramite .card-mensagem:hover{
    background-color: #fff !important;
  }

  .tramite .card-mensagem:hover p,
  .tramite .card-mensagem:hover span,
  .tramite .card-mensagem:hover label{color: #636363 !important}

  .line-label {
    line-height: 35px;
    text-align: right;
    border-bottom: 1px solid black
  }

  .label-info {
    line-height: 35px;
    border-bottom: 1px solid black
  }

  .fade-out {
    float: left;
    max-height: 0px;
    overflow: hidden;
    transition: 0.4s;
    padding: 0;
  }

  .fade-in {
    float: left;
    width: 100%;
    max-height: 1000px;
    transition: 0.4s;
    padding: 0;
  }
  
  .card-itens {
    margin-bottom: 10px;
    border: 1px;
    float: left;
    padding: 7px;
    border-color: #9c9c9c !important;
    cursor: pointer;
    transition: 0.2s;
    width: 100%;
    border-radius: 10px;
    box-shadow: #ddd 0px 5px 3px 3px;
  }

  #floating-button {
    z-index: 5 !important;
    padding-left: 14px!important; 
    padding-top: 7px!important; 
    font-size: 19px; 
    border-radius: 30px; 
    width:55px; 
    height:55px; 
    border: 4px solid #f7f7f7!important; 
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }

  #floating-button:hover {
    color: #9c1d1c!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/GerenciarSugestoes.vue